import { resetStore } from "store/actions";

const { createSlice } = require("@reduxjs/toolkit");
/* -------------------------------------------------------------------------- */
const initialState = {
  list: [],
  cargoData: [],
  paxData: [],
  paxByRouteData: [],
  canceledFlightsData: [],
  delays: [],
  pilotFuelPerformanceData: [],
  pilotFuelPerformanceSummary: null,
  fuelMonitoringData: [],
  fuelMonitoringTotal: 0,
  fuelMonitoringSummary: null,
  fuelMonitoringUnit: null,
  flightPerformanceData: [],
  flightPerformanceTotal: 0,
  flightPerformanceSummary: null,
  filters: {
    fields: [],
    type: null,
    from: null,
    to: null,
    aircraft: null,
    delayCode: null,
    delayCode_category: undefined,
    fleet: null,
    flight_number: null,
    userId: null, //crew
    positionId: null,
    currencyType: null,
    weightUnit: null,
    dataSource: null,
    version: null,
    crew: [],
    origins: [], // pilot-fuel-performance: multi-select airports
    destinations: [], // pilot-fuel-performance: multi-select airports
    mqf: 20, // pilot-fuel-performance: minimum qualifying flights
    sortBy: "performance:1",
    fmPage: 1, // fuel-monitoring: pagination
    fmLimit: 25, // fuel-monitoring: pagination
    fmSortBy: "scheduled_time_of_departure:desc", // fuel-monitoring: sorting
    fpPage: 1, // flight-performance: pagination
    fpLimit: 25, // flight-performance: pagination
    fpSortBy: "scheduled_time_of_departure:desc", // flight-performance: sorting
  },
};

const reportsSlice = createSlice({
  name: "reports",
  initialState,
  extraReducers: (builder) => builder.addCase(resetStore, () => initialState),
  reducers: {
    setReportsList: (state, action) => {
      state.list = action.payload;
    },
    setReportFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setCargoData: (state, action) => {
      state.cargoData = action.payload;
    },
    setPaxByRouteData: (state, action) => {
      state.paxByRouteData = action.payload;
    },
    setPaxData: (state, action) => {
      state.paxData = action.payload;
    },
    setCanceledFlightsData: (state, action) => {
      state.canceledFlightsData = action.payload;
    },
    setDelays: (state, action) => {
      state.delays = action.payload;
    },
    setPilotFuelPerformanceData: (state, action) => {
      state.pilotFuelPerformanceData = action.payload;
    },
    setPilotFuelPerformanceSummary: (state, action) => {
      state.pilotFuelPerformanceSummary = action.payload;
    },
    setFuelMonitoringData: (state, action) => {
      state.fuelMonitoringData = action.payload;
    },
    setFuelMonitoringTotal: (state, action) => {
      state.fuelMonitoringTotal = action.payload;
    },
    setFuelMonitoringSummary: (state, action) => {
      state.fuelMonitoringSummary = action.payload;
    },
    setFuelMonitoringUnit: (state, action) => {
      state.fuelMonitoringUnit = action.payload;
    },
    setFlightPerformanceData: (state, action) => {
      state.flightPerformanceData = action.payload;
    },
    setFlightPerformanceTotal: (state, action) => {
      state.flightPerformanceTotal = action.payload;
    },
    setFlightPerformanceSummary: (state, action) => {
      state.flightPerformanceSummary = action.payload;
    },
  },
});

const { actions } = reportsSlice;
export const {
  setReportsList,
  setReportFilters,
  setCargoData,
  setPaxByRouteData,
  setPaxData,
  setCanceledFlightsData,
  setDelays,
  setPilotFuelPerformanceData,
  setPilotFuelPerformanceSummary,
  setFuelMonitoringData,
  setFuelMonitoringTotal,
  setFuelMonitoringSummary,
  setFuelMonitoringUnit,
  setFlightPerformanceData,
  setFlightPerformanceTotal,
  setFlightPerformanceSummary,
} = actions;

export const selReportsList = (state) => state.reports.list;
export const selReportsFilters = (state) => state.reports.filters;
export const selCargoData = (state) => state.reports.cargoData;
export const selPaxData = (state) => state.reports.paxData;
export const selPaxByRouteData = (state) => state.reports.paxByRouteData;
export const selCanceledFlightsData = (state) =>
  state.reports.canceledFlightsData;
export const selDelays = (state) => state.reports.delays;
export const selPilotFuelPerformanceData = (state) =>
  state.reports.pilotFuelPerformanceData;
export const selPilotFuelPerformanceSummary = (state) =>
  state.reports.pilotFuelPerformanceSummary;
export const selFuelMonitoringData = (state) =>
  state.reports.fuelMonitoringData;
export const selFuelMonitoringTotal = (state) =>
  state.reports.fuelMonitoringTotal;
export const selFuelMonitoringSummary = (state) =>
  state.reports.fuelMonitoringSummary;
export const selFuelMonitoringUnit = (state) =>
  state.reports.fuelMonitoringUnit;
export const selFlightPerformanceData = (state) =>
  state.reports.flightPerformanceData;
export const selFlightPerformanceTotal = (state) =>
  state.reports.flightPerformanceTotal;
export const selFlightPerformanceSummary = (state) =>
  state.reports.flightPerformanceSummary;

const reducer = {
  reports: reportsSlice.reducer,
};

export default reducer;
